import { servedeckLogService } from '@/services/api/servedeckLog.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { servedeckLogModel } from '@/models/api/servedeckLog.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const SERVEDECK_LOG_MODULE = "api/servedeckLog";

// ACTIONS
export const GET_ALL_SERVEDECK_LOG = 'getAllServedeckLog';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_SERVEDECK_LOG_SUCCESS = "allServedeckLogSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_SERVEDECK_LOG]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        servedeckLogService
            .getAll(filter)
            .then((result) => {
                commit(ALL_SERVEDECK_LOG_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_SERVEDECK_LOG_SUCCESS](state, {data}) {
        let servedeckLogList = data.data || [];
        state.list.data = servedeckLogList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = servedeckLogList.map(item => servedeckLogModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};
